import { render, staticRenderFns } from "./options-edit-bulk.vue?vue&type=template&id=18f1bd50&"
import script from "./options-edit-bulk.vue?vue&type=script&lang=js&"
export * from "./options-edit-bulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports